import React from 'react'
import {map} from "lodash";
import {Divider, Header, Label} from "semantic-ui-react";
import styled from 'styled-components';

import { __ } from '~/i18n'

import { CartItem, CartTotal, CartHeader } from '~/components/cart'
import DiscountComponent from '~/scenes/discount'

const Footer = styled.footer``;
const SummaryCart = styled.div`
  padding: ${props => props.small ? '24px 16px 32px' : '24px 24px 32px'};
  
  .left {
    float: none !important;
  }
  
  footer {
    padding: 0 !important;
  }
`;
const Contents = styled.div`
  padding-bottom: 64px;
`;

export default class CartSummary extends React.PureComponent {
  render() {
    const { cart, count, shop, small } = this.props;
    let items;

    if(cart && cart.contents) {
      items = map(cart.contents, (cartItem) => {
        return (
          <CartItem compact key={cartItem.id} item={ cartItem } editable={ false }/>
        )
      })
    }

    return (
      <SummaryCart small={ small }>
        <CartHeader
          title={ __('Order Summary') }
          count={ count }
        />
        <Divider/>
        <Contents>
          { items }
        </Contents>
        <Footer>
          <DiscountComponent />
          <Divider />
          <CartTotal
            cart={ cart }
            shop={ shop }
          />
        </Footer>
      </SummaryCart>
    )
  }
}
